"use client";

import { useMatchNarrative } from "@/entities/replay-metrics";

import { MatchLaneMatchups, type LaneMatchup } from "./match-lane-matchups";

/**
 * KAN-814: контейнер витрины пар по ролям.
 *
 * Отделён от самой витрины, чтобы её можно было проверять тестами без мока сети —
 * как и остальные секции этого эпика.
 *
 * Реплеев у матча может не быть, а на арене пар по ролям не существует как понятия:
 * там больше двух сторон, и «лайн-оппонент» не определён. В обоих случаях бэкенд
 * отдаёт пустой список, и секция не рисуется вовсе — пустая рамка читалась бы как
 * поломка.
 */
export function MatchLaneMatchupsSection({ matchId }: { matchId: string }) {
  const { data } = useMatchNarrative(matchId);

  // Ответ — массив по игре матча. Пары берём из ПЕРВОЙ игры, где они есть, а не
  // склеиваем все: между играми состав линий меняется, и объединённая таблица
  // показала бы пару, которой на линии не было ни разу.
  const games = data ?? [];
  const withLanes = games.find((game) => (game.laneMatchups ?? []).length > 0);
  const matchups = (withLanes?.laneMatchups ?? []) as LaneMatchup[];

  if (matchups.length === 0) return null;

  return <MatchLaneMatchups matchups={matchups} />;
}
